// extracted by mini-css-extract-plugin
module.exports = {"container":"_1yhgXM_0KIa1X2p9nJl03F"};